import axios from "axios";

const patientsUrl = `${process.env.REACT_APP_BASE_URL}/services/userprofile/api/patients/backoffice`;
const patientsManagerUrl = `${process.env.REACT_APP_BASE_URL}/api/patients`;
const patientsBaseUrl = `${process.env.REACT_APP_BASE_URL}/services/userprofile/api`;

function urlManager(data = null) {
  let url = patientsUrl;
  if (data?.product)
    url = `${process.env.REACT_APP_BASE_URL}/proxy/${data.product}/services/userprofile/api/patients/backoffice`;
  return url;
}

function urlTmotosManager(data = null) {
  let url = patientsUrl;
  if (data?.product)
    url = `${process.env.REACT_APP_BASE_URL}/proxy/${data.product}/services/userprofile/api/t-motos`;
  return url;
}

const buildPatientsUrl = (params = {}) => {
  const query = new URLSearchParams();

  if (params.search) query.append("search", params.search);
  if (params.activated)
    query.append("activated", params.activated === "ACTIVO");
  if (params.financerPlan) query.append("financerPlan", params.financerPlan);
  if (params.financer) query.append("financer", params.financer);
  if (params.page) query.append("page", params.page);
  if (params.size) query.append("size", params.size);
  query.append("version","-v2")
  return `${patientsManagerUrl}${
    query.toString() ? `?${query.toString()}` : ""
  }`;
};

export const getPatientAdditionalData = async (token, patientId,product) => {
  return await axios
    .get(`${urlManager({product})}/get-additional-data/${patientId}`, {
      headers: { authorization: `Bearer ${token}` },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      // if (token) displayError("getPatients error: " + error.message);
    });
};

export const getPaymentMethod = async (token, userLogin,product) => {
  return await axios
    .get(`${urlManager({product})}/get-payment-method/${userLogin}`, {
      headers: { authorization: `Bearer ${token}` },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      // if (token) displayError("getPatients error: " + error.message);
    });
};

export const getPatients = async (token, displayError = () => {}, params) => {
  // let url = `${patientsUrl}${params?.query || params?.page ? "?" : ""}${
  //   params?.query && params?.query !== "" ? `search=` + params?.query : ``
  // }${params?.query && params?.page ? `&` : ""}${
  //   params?.page ? `page=` + params?.page : ``
  //   }`;
  return await axios
    .get(buildPatientsUrl(params), {
      headers: { authorization: `Bearer ${token}` },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (token) displayError("getPatients error: " + error.message);
    });
};

export const editPatient = async (token, data, displayError = () => {}) => {
  return await axios
    .put(`${urlManager(data)}/${data?.id}`, data, {
      headers: { authorization: `Bearer ${token}` },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (token) displayError("editPatient error: " + error.message);
    });
};

export const activatePatient = async (token, data, displayError = () => {}) => {
  return await axios
    .post(
      `${urlManager(data)}/${data?.id}`,
      { ...data, activated: true },
      { headers: { authorization: `Bearer ${token}` } }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (token) displayError("activatePatient error: " + error.message);
    });
};
export const disablePatient = async (
  token,
  id,
  reason,
  product = "mediline",
  displayError = () => {}
) => {
  let data = { product: product };
  return await axios
    .delete(`${urlManager(data)}/${id}/${reason}`, {
      headers: { authorization: `Bearer ${token}` },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (token) displayError("disablePatient error: " + error.message);
    });
};

export const createPatient = async (token, data, displayError = () => {}) => {
  return await axios
    .post(`${urlManager(data)}/create`, data, {
      headers: { authorization: `Bearer ${token}` },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (token) {
        // Encontramos la posición inicial del substring
        const startIndex = error.response.data.title.indexOf("[{");
        // Encontramos la posición final del substring
        const endIndex = error.response.data.title.indexOf("}]") + 2;
        // Extraemos el substring
        const jsonString = error.response.data.title.substring(
          startIndex,
          endIndex
        );

        // Convertimos el string JSON a un objeto JavaScript
        const errorObject = JSON.parse(jsonString);
        if (errorObject != null) {
          displayError(
            "Error Usuario Bonificado: " + errorObject[0].fieldErrors[0].message
          );
        } else displayError("Error Usuario Bonificado: " + error.message);
      }
    });
};

export const validatePatientExist = async (
  token,
  mail,
  dni,
  product = "mediline",
  displayError = () => {}
) => {
  return await axios
    .get(
      `${process.env.REACT_APP_BASE_URL}/proxy/${product}/services/userprofile/api/t-motos/validar-usuario?dni=${dni}&mail=${mail}`,
      {
        headers: { authorization: `Bearer ${token}` },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (token) displayError("activatePatient error: " + error.message);
    });
};

export const getFinancerPlans = async (
  token,
  displayError = () => {},
  product = "mediline"
) => {
  let url = `${process.env.REACT_APP_BASE_URL}/proxy/${product}/services/parametrics/api/financer-plans`;
  return await axios
    .get(url, { headers: { authorization: `Bearer ${token}` } })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      if (token) displayError("getFinancerPlans error: " + error.message);
    });
};

export const importPatients = async (token, data, displayError = () => {}) => {
  let product = "mediline";
  return await axios
    .post(`${patientsBaseUrl}/proxy/${product}/patient-import-file`, data, {
      headers: { authorization: `Bearer ${token}` },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (token) displayError("importPatient error: " + error.message);
    });
};

export const importPatientsGigaRed = async (
  token,
  data,
  displayError = () => {}
) => {
  let product = "mediline";
  return await axios
    .post(
      `${patientsBaseUrl}/proxy/${product}/patient-import-file-gigared`,
      data,
      {
        headers: { authorization: `Bearer ${token}` },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (token) displayError("importPatient error: " + error.message);
    });
};
